import { useState } from 'react';
import { CheckSquare } from 'lucide-react';

/**
 * Pulsante "Fine sessione" nell'header dei componenti chat del coach.
 *
 * Chiude esplicitamente la sessione di planning/review:
 *  - Pulisce la persistenza sessionStorage (feature: chat cross-navigation).
 *  - Salva il log finale su coach_log (via endSession del hook).
 *  - Resetta i messages (chat ripartirà da capo alla prossima visita).
 *
 * Ha una conferma inline di 3s: primo click → mostra "Sicuro?", secondo →
 * chiude davvero. Evita chiusure accidentali.
 */
export default function EndSessionButton({ onEnd, testid }) {
  const [confirming, setConfirming] = useState(false);

  const click = () => {
    if (!confirming) {
      setConfirming(true);
      setTimeout(() => setConfirming(false), 3000);
      return;
    }
    setConfirming(false);
    if (onEnd) onEnd();
  };

  return (
    <button
      type="button"
      onClick={click}
      className={`inline-flex items-center gap-2 px-3 py-1.5 border font-mono text-[10px] uppercase tracking-[0.18em] transition-colors ${
        confirming
          ? 'border-accent text-accent bg-accent/5'
          : 'border-line text-soft hover:border-ink hover:text-ink'
      }`}
      title={confirming ? 'Click di nuovo per confermare' : 'Chiude la sessione e salva lo storico'}
      data-testid={testid || 'end-session-btn'}
    >
      <CheckSquare size={12} strokeWidth={1.5} />
      {confirming ? 'Sicuro?' : 'Fine sessione'}
    </button>
  );
}
